import * as React from 'react';
const MAX_INITIAL_WAIT_FOR_LOADING_ANIMATION = 100;
export function useFirstLoad(loading, models) {
    const [firstLoad, setFirstLoad] = React.useState(true);
    const [hasSeenLoading, setHasSeenLoading] = React.useState(false);
    const stringifiedModels = JSON.stringify(models ?? {});
    React.useEffect(() => {
        if (models) {
            setFirstLoad(true);
            setHasSeenLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stringifiedModels]);
    React.useEffect(() => {
        if (loading) {
            setHasSeenLoading(true);
        }
    }, [loading]);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (firstLoad && hasSeenLoading && !loading) {
                setFirstLoad(false);
            }
        }, MAX_INITIAL_WAIT_FOR_LOADING_ANIMATION);
        return () => clearTimeout(timeout);
    }, [loading, firstLoad, hasSeenLoading]);
    return firstLoad;
}
